/* eslint-disable no-console */
import React from "react";
import { toast } from "src/state/state";
import { TranslationKey } from "src/types/translationKey";
import DebugAuthQuery from "src/ui/components/Debug/DebugAuthQuery";
import Payment from "src/ui/components/Payment/Payment";
import { PaymentContextWithPaymentCubit } from "src/ui/components/PaymentContext/PaymentContext";
import WithAuth from "src/ui/components/WithAuth/WithAuth";

const DebugAddPayment = () => {
  const subId = "123";
  return (
    <>
      <DebugAuthQuery />
      <WithAuth createAnonymousUser>
        <PaymentContextWithPaymentCubit>
          <Payment
            subscriptionId={subId}
            buyAction={async (_subscriptionId, options) => {
              console.log(
                "buyAction called with subscriptionId:",
                _subscriptionId
              );
              toast.success(
                "Payment method saved successfully" as TranslationKey
              );
              options?.onSuccess?.();
              return true;
            }}
            onError={() => console.log("Payment error")}
            onComplete={() => console.log("Payment complete")}
          />
        </PaymentContextWithPaymentCubit>
      </WithAuth>
    </>
  );
};

export default DebugAddPayment;
